/**
 * Scroll Reveal — fade + translate-up sections as they enter the viewport.
 * Pre-paint: documentElement.classList.add('js-reveal') (set inline in <head>).
 * Targets: direct children of <main> (each .shopify-section wrapper).
 *
 * Sections already in view at load get revealed immediately (no flash).
 * Each subsequent section fades in once when 10% visible.
 */

(() => {
  const ROOT = document.documentElement;
  if (!ROOT.classList.contains('js-reveal')) return; // reduced-motion or pre-paint failed

  const main = document.getElementById('main-content');
  if (!main) return;

  const targets = Array.from(main.children).filter((el) => {
    return el.nodeType === 1 && !el.hasAttribute('data-reveal-skip');
  });

  if (!targets.length) return;

  targets.forEach((el) => el.setAttribute('data-reveal', ''));

  const reveal = (el) => {
    el.setAttribute('data-revealed', '');
    el.removeAttribute('data-reveal');
  };

  if (!('IntersectionObserver' in window)) {
    targets.forEach(reveal);
    return;
  }

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          reveal(entry.target);
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach((el) => {
    const rect = el.getBoundingClientRect();
    const inView = rect.top < window.innerHeight && rect.bottom > 0;
    if (inView) {
      reveal(el);
    } else {
      io.observe(el);
    }
  });
})();
